import { colorsPalettes } from "@similarweb/styles";
import { ChangeValue, ProgressBar } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { IPopCardRowAutomationIds } from "./automationIds";

const BAR_HEIGHT = "16px";

interface IConversionRatePopBarRowProps {
    rowLabel: string;
    value: number;
    barFraction: number;
    barColor: string;
    formatValue: (value: number) => string;
    change?: number | null;
    formatChange?: (change: number) => string;
    changeSuffix?: string;
    automationIds: IPopCardRowAutomationIds;
}

export const ConversionRatePopBarRow = ({
    rowLabel,
    value,
    barFraction,
    barColor,
    formatValue,
    change,
    formatChange,
    changeSuffix,
    automationIds,
}: IConversionRatePopBarRowProps) => {
    const hasChange = change != null && formatChange != null;

    return (
        <Flex
            flexDirection="column"
            gap="8px"
            data-automation={automationIds.row}
        >
            <Flex
                alignItems="center"
                gap="6px"
            >
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[400]}
                    data-automation={automationIds.dateRange}
                >
                    {rowLabel}
                </Text>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[250]}
                >
                    •
                </Text>
                <Text
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon[500]}
                    data-automation={automationIds.value}
                >
                    {formatValue(value)}
                </Text>
                {hasChange ? (
                    <>
                        <Text
                            fontVariant="body2"
                            color={colorsPalettes.carbon[200]}
                        >
                            •
                        </Text>
                        <Flex
                            alignItems="center"
                            gap="4px"
                        >
                            <ChangeValue
                                value={formatChange(change)}
                                isDecrease={change < 0}
                                unsigned={change === 0}
                            />
                            {changeSuffix ? (
                                <Text
                                    fontVariant="body2"
                                    color={colorsPalettes.carbon[400]}
                                    data-automation={automationIds.changeSuffix}
                                >
                                    {changeSuffix}
                                </Text>
                            ) : null}
                        </Flex>
                    </>
                ) : null}
            </Flex>
            <ProgressBar
                data-automation={automationIds.bar}
                values={[barFraction]}
                colorSet={[barColor]}
                height={BAR_HEIGHT}
            />
        </Flex>
    );
};
